export class SifremiUnuttumRequestModel {
    email: string;
    googleCaptchaToken: string;
}
